import { NavTopic } from './appNavigation';

export const ENTERPRISE_PRIMARY_NAV_TOPICS: NavTopic[] = [
  { label: 'Home', path: '/enterprise/dashboard' },
  {
    label: 'Organization',
    path: '/enterprise/profile',
    children: [
      { label: 'Company profile', path: '/enterprise/profile' },
      { label: 'Compliance workflow', path: '/enterprise/workflow' },
    ],
  },
  {
    label: 'Data',
    path: '/enterprise/data',
    children: [
      { label: 'Data connectors', path: '/enterprise/data?section=connectors' },
      { label: 'Imported activity', path: '/enterprise/data?section=operational' },
      { label: 'Documents', path: '/enterprise/data?section=documents' },
    ],
  },
  {
    label: 'Carbon inventory',
    path: '/enterprise/carbon-footprint',
    children: [
      { label: 'Scope 1–2', path: '/enterprise/carbon-footprint?section=scope12' },
      { label: 'Scope 3 materiality', path: '/enterprise/carbon-footprint?section=scope3' },
      { label: 'Assessment results', path: '/enterprise/carbon-footprint?section=results' },
    ],
  },
  {
    label: 'Compliance',
    path: '/enterprise/compliance',
    children: [
      { label: 'BRSR & India mandates', path: '/enterprise/compliance' },
      { label: 'Disclosure reports', path: '/enterprise/reporting' },
    ],
  },
  {
    label: 'Pricing',
    path: '/enterprise/pricing',
  },
];

export const ENTERPRISE_SECONDARY_NAV_TOPICS: NavTopic[] = [
  { label: 'Settings', path: '/enterprise/settings' },
  { label: 'Data privacy', path: '/enterprise/data-privacy' },
  { label: 'Help center', path: '/help' },
];
